import React from "react";
import {createRoot} from "react-dom/client";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";
import {HttpClient} from "@sentry/integrations";
const WiseBerryAPIEnv = process.env.VITE_API_KEY;

// https://uat.wiseberryonline.com.au/api/v1/
let environment = "development";
if (WiseBerryAPIEnv.startsWith("https://uat")) {
  environment;
} else if (WiseBerryAPIEnv.startsWith("https://api")) {
  environment = "production";
}

// let dialogShown = false;
Sentry.init({
  dsn: "https://5375082aaed509ad6e46a8c52c957f56@o4504518141345792.ingest.sentry.io/4505938091048960",
  integrations: [
    new Sentry.BrowserTracing({
      tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    }),
    new Sentry.Integrations.Breadcrumbs({
      console: false,
    }),
    new HttpClient({
      failedRequestStatusCodes: [403, 404, 429, 503, 504],
    }),
    new Sentry.Replay(),
  ],
  sendDefaultPii: false,
  environment: environment,
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // beforeSend(event, hint) {
  //   let dialogShown = false;

  //   // Check if the event is an exception and if it is a 401 error
  //   if (event.exception) {
  //     const is401Error = (event.exception.values || []).some((value) => {
  //       return (
  //         value.type === "UnhandledRejection" &&
  //         value.value &&
  //         value.value.includes("Request failed with status code 401")
  //       );
  //     });

  //     if (is401Error && environment === "production") {
  //       // Ignore the 401 error by returning null
  //       return null;
  //     } else if (!dialogShown) {
  //       // Optionally: show the report dialog for non-401 errors
  //       Sentry.showReportDialog({
  //         eventId: event.event_id,
  //         user: {name: event?.user?.username, email: event?.user?.email},
  //       });
  //       dialogShown = true;
  //     }
  //   }

  //   return event;
  // },
});

const container = document.getElementById("root");
const root = createRoot(container);
// const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
